<template>
  <div>
    <div class="row">
      <div class="col-lg-12" ref="post-editor" style="display: none;">
        <div class="ibox">
          <div class="ibox-title"><h5>Edit content</h5></div>
          <div class="ibox-content">
            <div class="row">
              <div class="col-lg-2">Title</div>
              <div class="col-lg-10"><input type="text" name="" id="pageTitle" class="col-lg-6" v-model="pageTitle"></div>
            </div>
            <div class="row">
              <div class="col-lg-2">Language</div>
              <div class="col-lg-10">
                <select v-model="pageLanguage">
                  <option value="js">JavaScript</option>
                  <option value="css">CSS</option>
                  <option value="html">HTML</option>
                </select>
              </div>
              <div class="col-lg-2">Position</div>
              <div class="col-lg-10">
                <select v-model="pageType">
                  <option value="header">Header</option>
                  <option value="body_open">Body</option>
                  <option value="footer">Footer</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-2">Content</div>
              <div class="col-lg-10"><textarea name="" id="pageConent" class="col-lg-12" rows="10" ref="pageContnet" v-model="pageContent"></textarea></div>
              <input type="hidden" name="pageId" v-model="pageId">
            </div>
            <div class="row">
              <div class="col-lg-12">
                <button class="pull-right btn btn-primary" @click="savePost"><i class="fa-upload fa"></i> Save</button>
                <button class="pull-right btn btn-info" type="reset" @click="stopEdit">Close</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="table-responsive col-lg-12">
        <table class="table table-striped table-bordered table-hover dataTables-example">
          <thead>
          <tr>
            <th>Title</th>
            <th>Name</th>
            <th>Position</th>
            <th>Added</th>
            <th>Modified</th>
            <th>Status</th>
            <th><button class="btn btn-info btn-xs" @click="loadPost(0)"><i class="fa fa-plus"></i> New</button></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="post in posts" :key="post.ID">
            <td>
              <span :class="'btn-xs lang-btn lang-' + post.options.language" v-if="post.options.language">{{ post.options.language }}</span>
              {{ post.post_title }}
            </td>
            <td>{{ post.post_name }}</td>
            <td>{{ postData[post.ID].options.type }}</td>
            <td>{{ $moment(post.post_date).format('DD.MM.YYYY HH:mm') }}</td>
            <td>{{ $moment(post.post_modified).format('DD.MM.YYYY HH:mm') }}</td>
            <td>{{ post.post_status }}</td>
            <td>
              <i class="fa fa-trash-o tag-icon" @click="deletePost(post.ID)"></i>
              <i class="fa fa-pencil-square-o tag-icon" @click="loadPost(post.ID)"></i>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Title</th>
            <th>Name</th>
            <th>Position</th>
            <th>Added</th>
            <th>Modified</th>
            <th>Status</th>
            <th>&nbsp;</th>
          </tr>
          </tfoot>
        </table>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Content',
  data () {
    return {
      posts: [],
      postData: [],
      pageTitle: '',
      pageContent: '',
      pageLanguage: 'js',
      pageType: 'header',
      pageId: ''
    }
  },
  props: ['site'],
  mounted () {
    this.loadPosts('custom-css-js')
  },
  methods: {
    loadPosts (type) {
      axios.get('/am/plugin/site/' + this.site.url + '/posts?type=' + type)
        .then(r => {
          this.posts = r.data.data
          r.data.data.forEach(val => {
            this.postData[val.ID] = val
          })
        })
        .catch(e => {
          this.$toastr.error(e, 'Bad shit')
        })
    },
    deletePost (id) {
      if (confirm('Delete post?')) {
        axios.delete('/am/plugin/site/' + this.site.url + '/post?id=' + id)
          .then(r => {
            this.$toastr.success('Post annihilated!', 'Great stuff!')
            this.loadPosts('custom-css-js')
          })
          .catch(e => {
            this.$toastr.error(e, 'My oh my...')
          })
      }
    },
    loadPost (id) {
      if (id) {
        this.pageTitle = this.postData[id].post_title
        this.pageContent = this.postData[id].post_content
        this.pageType = this.postData[id].options.type || 'header'
        this.pageId = id
        this.pageLanguage = this.postData[id].options.language || 'js'
      } else {
        this.pageTitle = this.pageContent = this.pageId = ''
        this.pageLanguage = 'js'
      }
      this.$refs['post-editor'].style.display = 'block'
    },
    savePost () {
      axios.post('/am/plugin/site/' + this.site.url + '/post', {
        id: this.pageId,
        title: this.pageTitle,
        content: this.pageContent,
        type: 'custom-css-js',
        language: this.pageLanguage,
        pageType: this.pageType
      })
        .then(r => {
          this.$toastr.success('Post successfully ' + this.id ? 'updated' : 'added', 'Party on!')
          this.loadPosts('custom-css-js')
          this.stopEdit()
        })
        .catch(e => {
          this.$toastr.error('QQ. ' + e, 'Oh wie Schade')
        })
    },
    stopEdit () {
      this.pageTitle = this.pageContent = this.pageId = ''
      this.pageLanguage = 'js'
      this.$refs['post-editor'].style.display = 'none'
    }
  }
}
</script>

<style scoped>
  .tag-icon {
    cursor: pointer;
  }
  .tag-icon:hover {
    color: green;
  }
  .lang-btn {
    color: white;
    text-align: center;
  }
  .lang-html {
    background: #e45126;
  }
  .lang-css {
    background: #0c73b8;
  }
  .lang-js {
    background: #e4a228;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/Manager/Site/Content.vue